import type { ComponentTemplate } from "@v1/types/component-template";
import type { ReploElementType } from "schemas/generated/element";

import { elementTypeToEditorData } from "@v1/components/editor/element";
import { getNewPagePlaceholderComponent } from "replo-templates/newPagePlaceholder";

const blankPreviews: Record<ReploElementType, string> = {
  page: "blank-page.svg",
  shopifyArticle: "blank-post.svg",
  shopifySection: "blank-section.svg",
  shopifyProductTemplate: "",
};

const blankPreviewsSelected: Record<ReploElementType, string> = {
  page: "blank-page-filled.svg",
  shopifyArticle: "blank-post-filled.svg",
  shopifySection: "blank-section-filled.svg",
  shopifyProductTemplate: "",
};

export const getEmptyTemplate = (
  elementType: ReploElementType,
): ComponentTemplate => {
  return {
    id: `blank-${elementType ?? "page"}-template`,
    name: `Blank ${
      elementType
        ? elementTypeToEditorData[elementType].singularDisplayName
        : "Page"
    }`,
    scope: "store",
    type: elementType && elementType === "shopifySection" ? "section" : "page",
    storeId: null,
    preview: blankPreviews[elementType],
    selectedPreview: blankPreviewsSelected[elementType],
    template: getNewPagePlaceholderComponent(elementType),
  };
};
